import PropTypes from 'prop-types';
import React from 'react';
import ModalBase from '@molecules/ModalBase';
import { BodyLarge, H2 } from '@react/styledComponents';

const MultiCurrencyCartModal = ({ isOpen, onClose }) => {
    return (
        <ModalBase
            isOpen={isOpen}
            stylesBody={{
                paddingBottom: '64px',
                paddingLeft: '64px',
                paddingRight: '64px',
                paddingTop: '24px',
            }}
            onClose={onClose}
        >
            <H2>Unable to add to cart</H2>
            <BodyLarge className="mt-1.875rem">
                You currently have membership dues and/or event registrations from a different locale in your cart, and
                this system does not yet support multi-currency. Please complete checkout or remove those items from
                your cart, then you may purchase this event. We apologize for the inconvenience.
            </BodyLarge>
        </ModalBase>
    );
};

MultiCurrencyCartModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default MultiCurrencyCartModal;
